import React from "react";
var logo = function logo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M39.21 0h6.131v10.976c2.406-2.305 5.079-3.274 7.418-3.274 7.468 0 13.7 6.13 13.7 13.599 0 7.518-6.132 13.699-13.7 13.699s-13.566-5.714-13.566-13.75V0h.017zm13.566 29.387c4.343 0 7.518-3.926 7.518-8.07 0-4.293-3.091-7.985-7.518-7.985-4.561 0-7.418 3.558-7.418 7.935-.017 4.093 3.074 8.12 7.418 8.12zm67.143 4.744h-5.63v-3.174c-2.038 2.406-4.795 4.01-7.936 4.01-7.468 0-13.7-6.132-13.7-13.6 0-7.517 6.132-13.699 13.7-13.699s13.566 5.764 13.566 13.75V34.13zm-13.566-20.85c-4.327 0-7.518 3.927-7.518 8.07 0 4.293 3.091 7.986 7.518 7.986 4.561 0 7.418-3.559 7.418-7.936 0-4.11-3.09-8.12-7.418-8.12zm-79.155-5.63c-3.174 0-6.048 1.254-8.07 3.325-2.02-2.071-4.894-3.324-8.018-3.324-1.788 0-3.475.4-4.979 1.119v-.952H0V34.13h6.131V18.193a5.029 5.029 0 0 1 5.029-4.895c2.723 0 4.928 2.256 4.928 5.029v15.821h6.132V18.31a5.034 5.034 0 0 1 5.028-5.028c2.723 0 4.929 2.255 4.929 5.028v15.821h6.13V18.778c.018-6.549-5.011-11.126-11.109-11.126zm52.358 0c-2.222 0-4.293.485-6.081 1.404V7.819h-6.131v26.296h6.13V19.363a6.05 6.05 0 0 1 6.082-6.081 6.071 6.071 0 0 1 6.081 6.08v14.753h6.131V19.446c.017-7.217-5.48-11.794-12.212-11.794z"
  }));
};
logo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "120",
  height: "35",
  viewBox: "0 0 120 35"
};
export default {
  base: logo,
  wide: logo
};